import { FieldDevelopmentTeamBase } from './base/field-development-team-base';

export class FieldDevelopmentTeam extends FieldDevelopmentTeamBase { }